export default "__VITE_ASSET__Co3X7E68cCCs3Bf1EatIfA__"